import { StarFilled } from '@ant-design/icons';
import EntityLogo from 'components/EntityLogo';
import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';
import moment from 'moment';
import { formatDate, formatTime } from 'utils/generateEntityColumns';
import useIsMobile from 'hooks/useIsMobile';

const GamesPlayer = () => {
  const entities = useEntities();
  const isMobile = useIsMobile();

  const filterGroups = [
    [
      { label: isMobile ? 'Past (team)' : 'Past games of my team', preferredSort: { column: 'StartDateTime-nowrap', direction: 'descend' }, filters: { startDate: ['<' + moment().format('YYYY-MM-DD')], PlayedByMyTeam: 1 } },
      { label: isMobile ? 'Past (me)' : 'Past games played by me',      preferredSort: { column: 'StartDateTime-nowrap', direction: 'descend' }, filters: { startDate: ['<' + moment().format('YYYY-MM-DD')], PlayedByMe: 1 } },
      { label: isMobile ? 'Future (team)' : 'Future games of my team',      preferredSort: { column: 'StartDateTime-nowrap', direction: 'ascend' }, filters: { startDate: ['>' + moment().subtract(1, 'days').format('YYYY-MM-DD')], PlayedByMyTeam: 1 } },
    ],
  ];

  return (
    <HmsEntityTableController
      entity={entities.Game}
      filterGroups={filterGroups}
      exportEnabled={false}
      extraAttributes="HomeTeamGoals,AwayTeamGoals,StatGoals,StatAssists,StatPoints,StatPenaltyMinutes,IsStar"
      showColumns={[
        { column: 'StartDateTime-nowrap', width: 200, defaultSortOrder: 'descend', fixed: 'left' },
        { column: 'Venue', width: 200, },
        { column: 'HomeTeam-nick', width: 150, },
        { column: 'Score', width: 80, },
        { column: 'AwayTeam-nick', width: 150, },
        'PlayerStar',
        'PlayerGoals',
        'PlayerAssists',
        'PlayerPoints',
        'PlayerPenaltyMinutes',
        'PlayerSpecial',
      ]}
      renderMobileRow={(record) => (
        <div>
          <div className="border-b-[1px] border-gray-100 px-4 py-4 flex rounded-t-md" style={{ background: 'linear-gradient(90deg, #f2f2f2 0%, #fafafa 2%, #fafafa 98%, #f2f2f2 100%)' }}>
            <div className="flex flex-col gap-[1px]">
              <div className="font-bold whitespace-nowrap text-[0.9rem]">{
                formatDate(record.startDate, { withWeekDay: true }) +
                (record.startDate && record.startDate != '' && record.startTime && record.startTime != '' ? ', ' : '') +
                formatTime(record.startTime)
              }</div>
              {/* <div className="text-gray-400 whitespace-nowrap text-[0.8rem]">{
                record.Venue?.name
              }</div> */}
            </div>
            <div className="ml-auto my-auto flex items-center gap-2">
              {record.IsStar == 1 && (
                <StarFilled className="text-yellow-500 text-base" />
              )}
              {record.StatGoals >= 3 && record.StatPoints < 4 && (
                <span className="bg-green-500 text-white rounded px-2 py-1 whitespace-nowrap text-xs font-semibold">H</span>
              )}
              {record.StatPoints >= 3 && !(record.StatGoals >= 3 && record.StatPoints < 4) && (
                <span className="bg-blue-500 text-white rounded px-2 py-1 whitespace-nowrap text-xs font-semibold">{record.StatPoints}+P</span>
              )}
              {/* <HmsStatusTag className="m-0" status={record.status} entity="Game" /> */}
            </div>
          </div>
          <div className="px-6 py-4 flex items-center text-[1.05rem] rounded-b-md" style={{ background: 'linear-gradient(90deg, #f8f8f8 0%, #fff 2%, #fff 98%, #f8f8f8 100%)' }}>
            <div className="flex-1 flex-shrink-0 text-right pr-3">{record.HomeTeam?.nick}</div>
            <div className="w-[30px] text-center"><EntityLogo entity={record.HomeTeam} size={32} /></div>
            <div className="w-[60px] text-center">
              <div className="font-bold font-mono text-[1.1rem] whitespace-nowrap">
                {(record.HomeTeamGoals != 0 || record.AwayTeamGoals != 0 || record.status == 'RUNNING' || record.status == 'FINISHED') 
                  ? `${record.HomeTeamGoals}:${record.AwayTeamGoals}` 
                  : '-:-'}
              </div>
            </div>
            <div className="w-[30px] text-center"><EntityLogo entity={record.AwayTeam} size={32} /></div>
            <div className="flex-1 flex-shrink-0 text-left pl-3">{record.AwayTeam?.nick}</div>
          </div>
          <div className="px-6 py-3 flex items-center justify-between text-[0.85rem] text-gray-600" style={{ background: 'linear-gradient(90deg, #f8f8f8 0%, #fff 2%, #fff 98%, #f8f8f8 100%)' }}>
            <span className="flex-1 text-center">G:{record.StatGoals || 0}</span>
            <span className="flex-1 text-center">A:{record.StatAssists || 0}</span>
            <span className="flex-1 text-center">PTS:{record.StatPoints || 0}</span>
            <span className="flex-1 text-center">PIM:{record.StatPenaltyMinutes || 0}</span>
          </div>
        </div>
      )}
      onRowClickLink={(record) => {
        window.open(`/embed/game?gameId=${record.gameId}`, '_blank');
        // todo: how to get which lang?
      }}
      canCreate={false}
    />
  )
}

export default GamesPlayer 